document.addEventListener('DOMContentLoaded', function () {
  initWallpaperCalculator();
  initQuoteRequestForm();
  initFabricMinimumQuantity();
  initCollectionFilterSubmit();
  initCurtainModule();
  initSampleAddLimit();
  initVariantTitleUpdate();
});
function initVariantTitleUpdate() {

  document.addEventListener('variant:change', function(event) {

    const variant = event.detail && event.detail.variant;

    if (!variant) return;

    const selectedOptions = variant.options || [];

    const optionContainers = document.querySelectorAll('.variant-picker__option-info');

    optionContainers.forEach(function(container, index){

      const value = container.querySelector('span');

      if(value && selectedOptions[index]){
        value.textContent = selectedOptions[index];
      }

    });

  });

}
function initCollectionFilterSubmit() {
  document.addEventListener('change', function (event) {
    const input = event.target;

    if (!input.matches('input[name^="filter."]')) return;

    const form = input.closest('form');

    if (form) {
      form.submit();
    }
  });
}
function initFabricMinimumQuantity() {
  const controls = document.querySelectorAll('[data-custom-qty-control]');
  if (!controls.length) return;

  controls.forEach(function (control) {
    const form = control.closest('form');
    const displayInput = control.querySelector('[data-custom-display-qty]');
    const realInput = form ? form.querySelector('[data-custom-real-qty]') : null;
    const minusButton = control.querySelector('[data-custom-qty-minus]');
    const plusButton = control.querySelector('[data-custom-qty-plus]');

    const minQty = parseFloat(control.dataset.minQuantity || '1');
    const step = parseFloat(control.dataset.quantityStep || '1');
    const unitLabel = control.dataset.unitLabel || 'item(s)';

    if (!form || !displayInput || !realInput || !minusButton || !plusButton) return;

    function normalizeNumber(value) {
      const decimals = String(step).includes('.')
        ? String(step).split('.')[1].length
        : 0;

      return Number(value).toFixed(decimals).replace(/\.0+$/, '');
    }

    function setValue(value, showAlert) {
      let nextValue = parseFloat(value);

      if (!nextValue || nextValue < minQty) {
        nextValue = minQty;

        if (showAlert) {
          alert(`Minimum order is ${minQty} ${unitLabel}.`);
        }
      }

      const normalized = normalizeNumber(nextValue);

      displayInput.value = normalized;
      realInput.value = normalized;

      minusButton.disabled = nextValue <= minQty;
    }

    setValue(displayInput.value || minQty, false);

    plusButton.addEventListener('click', function () {
      const currentValue = parseFloat(displayInput.value || minQty);
      setValue(currentValue + step, false);
    });

    minusButton.addEventListener('click', function () {
      const currentValue = parseFloat(displayInput.value || minQty);
      setValue(currentValue - step, true);
    });

    displayInput.addEventListener('change', function () {
      setValue(displayInput.value, true);
    });

    displayInput.addEventListener('blur', function () {
      setValue(displayInput.value, true);
    });

    form.addEventListener('submit', function (event) {
      const currentValue = parseFloat(displayInput.value || '0');

      if (!currentValue || currentValue < minQty) {
        event.preventDefault();
        setValue(minQty, true);
      } else {
        setValue(currentValue, false);
      }
    });
  });
}
function initQuoteRequestForm() {
  const forms = document.querySelectorAll('[data-quote-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const status = form.querySelector('[data-quote-status]');
      const btn_text = form.querySelector('button.quote-form-btn');
      const button = form.querySelector('button[type="submit"]');

      if (status) {
        status.hidden = false;
        status.textContent = 'richiesta di preventivo in arrivo...';
        status.classList.remove('text-success', 'text-error');
      }

      if (button) {
        button.disabled = true;
      }

      try {
        const formData = new FormData(form);
        const body = new URLSearchParams(formData);

        const response = await fetch('/apps/request-quote', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          body
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(data.message || 'Request failed.');
        }

        if (status) {
          //status.textContent = data.message || 'Request has been Sent.';
          //status.classList.add('text-success');
          status.hidden = true;
          btn_text.textContent = 'ti risponderemo a breve.';
        }

        form.reset();
      } catch (error) {
        if (status) {
          //status.textContent = error.message || 'Sorry, Please try again.';
          //status.classList.add('text-error');
          status.hidden = true;
          btn_text.textContent = 'ti risponderemo a breve.';
        }
      } finally {
        if (button) {
          button.disabled = false;
        }
      }
    });
  });
}

function initWallpaperCalculator() {
  const calculator = document.querySelector('.wallpaper-calculator');
  if (!calculator) return;

  const button = document.getElementById('CalculateWallpaperQty');
  const widthInput = document.getElementById('WallWidthCm');
  const heightInput = document.getElementById('WallHeightCm');
  const resultBox = calculator.querySelector('.calculator-result');
  const qtyOutput = document.getElementById('CalculatedQty');
  const unitOutput = document.getElementById('CalculatedUnit');
  const cartForm = document.getElementById('WallpaperCalculatedCartForm');
  const cartQtyInput = document.getElementById('WallpaperCartQty');
  const cartButton = calculator.querySelector('#WallpaperCalculatedCartForm button[type="submit"]');

  const variantInput =
    document.getElementById('WallpaperVariantId') ||
    calculator.querySelector('#WallpaperCalculatedCartForm input[name="id"]');

  const wallWidthProperty = document.getElementById('WallpaperWallWidthProperty');
  const wallHeightProperty = document.getElementById('WallpaperWallHeightProperty');
  const calculatedQtyProperty = document.getElementById('WallpaperCalculatedQtyProperty');

  if (
    !button ||
    !widthInput ||
    !heightInput ||
    !resultBox ||
    !qtyOutput ||
    !unitOutput ||
    !cartForm ||
    !cartQtyInput ||
    !variantInput ||
    !cartButton
  ) {
    console.warn('Wallpaper calculator: required elements missing.');
    return;
  }

  function getNumber(value) {
    const number = parseFloat(String(value || '').replace(',', '.'));
    return Number.isFinite(number) ? number : 0;
  }

  function normalizeSellingUnit(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function calculateWallpaperQuantity(wallWidthCm, wallHeightCm, productWidthCm, productLengthCm, patternRepeatCm) {
    if (!wallWidthCm || !wallHeightCm || !productWidthCm || !productLengthCm) {
      return 1;
    }

    const wallCols = Math.ceil(wallWidthCm / productWidthCm);

    const colSafeLengthCm = patternRepeatCm > 0
      ? Math.ceil(wallHeightCm / patternRepeatCm) * patternRepeatCm
      : wallHeightCm;

    const productRequiredLengthCm = patternRepeatCm > 0
      ? patternRepeatCm + (wallCols * colSafeLengthCm)
      : wallCols * colSafeLengthCm;

    const productQty = Math.ceil(productRequiredLengthCm / productLengthCm);

    return Math.max(1, productQty);
  }

  function calculateSquareMetreQuantity(wallWidthCm, wallHeightCm) {
    if (!wallWidthCm || !wallHeightCm) {
      return 1;
    }

    const wallAreaM2 = (wallWidthCm / 100) * (wallHeightCm / 100);
    return Math.ceil(wallAreaM2);
  }

  function updateSelectedVariantId(event) {

    const variant = event.detail && event.detail.variant;

    if (!variant) return;


    const variantTitleElement = document.querySelector('[data-selected-variant-title]');

    if (variantTitleElement) {
      if (variant.title && variant.title !== 'Default Title') {
        variantTitleElement.textContent = ' - ' + variant.title;
      } else {
        variantTitleElement.textContent = '';
      }
    }

  }

  document.addEventListener('variant:change', updateSelectedVariantId);

  button.addEventListener('click', function () {
    const wallWidthCm = getNumber(widthInput.value);
    const wallHeightCm = getNumber(heightInput.value);

    const sellingUnit = normalizeSellingUnit(calculator.dataset.sellingUnit);
    const rollWidthCm = getNumber(calculator.dataset.rollWidthCm);
    const rollLengthCm = getNumber(calculator.dataset.rollLengthCm);
    const verticalRepeatCm = getNumber(calculator.dataset.verticalRepeatCm || 0);

    if (!wallWidthCm || !wallHeightCm) {
      alert('Inserisci larghezza e altezza della parete.');
      return;
    }

    let requiredQty = 1;
    let unitLabel = 'unità';

    if (sellingUnit === 'rollo' || sellingUnit === 'roll') {
      if (!rollWidthCm) {
        alert('Roll width is missing in product metafields.');
        return;
      }

      if (!rollLengthCm) {
        alert('Roll length is missing in product metafields.');
        return;
      }

      requiredQty = calculateWallpaperQuantity(
        wallWidthCm,
        wallHeightCm,
        rollWidthCm,
        rollLengthCm,
        verticalRepeatCm
      );

      unitLabel = 'rollo/i';
    } else if (sellingUnit === 'metro lineare') {
      if (!rollWidthCm) {
        alert('Roll width is missing in product metafields.');
        return;
      }

      requiredQty = calculateWallpaperQuantity(
        wallWidthCm,
        wallHeightCm,
        rollWidthCm,
        rollLengthCm || 100,
        verticalRepeatCm
      );

      unitLabel = 'metro/i lineare/i';
    } else if (
      sellingUnit === 'm2' ||
      sellingUnit === 'm²' ||
      sellingUnit === 'mq' ||
      sellingUnit === 'sqm'
    ) {
      requiredQty = calculateSquareMetreQuantity(wallWidthCm, wallHeightCm);
      unitLabel = 'm²';
    } else if (sellingUnit === 'campione') {
      requiredQty = 1;
      unitLabel = 'campione';
    } else if (sellingUnit === 'murale') {
      requiredQty = 1;
      unitLabel = 'murale';
    } else {
      requiredQty = 1;
      unitLabel = 'unità';
    }

    requiredQty = Math.max(1, requiredQty);

    console.log('Wallpaper calculator values:', {
      sellingUnit,
      wallWidthCm,
      wallHeightCm,
      rollWidthCm,
      rollLengthCm,
      verticalRepeatCm,
      requiredQty
    });

    qtyOutput.textContent = requiredQty;
    unitOutput.textContent = unitLabel;
    cartQtyInput.value = requiredQty;

    if (wallWidthProperty) {
      wallWidthProperty.value = wallWidthCm + ' cm';
    }

    if (wallHeightProperty) {
      wallHeightProperty.value = wallHeightCm + ' cm';
    }

    if (calculatedQtyProperty) {
      calculatedQtyProperty.value = requiredQty + ' ' + unitLabel;
    }

    resultBox.hidden = false;
    cartButton.disabled = false;
  });

  cartForm.addEventListener('submit', function () {
    const currentQty = parseInt(cartQtyInput.value, 10);

    if (!currentQty || currentQty < 1) {
      cartQtyInput.value = 1;
    }
  });
}

  function calculateLinearMetreQuantity(wallWidthCm, wallHeightCm, rollWidthCm) {
    if (!wallWidthCm || !wallHeightCm || !rollWidthCm) {
      return 1;
    }

    const wallAreaM2 = (wallWidthCm / 100) * (wallHeightCm / 100);
    const rollWidthM = rollWidthCm / 100;

    return Math.ceil(wallAreaM2 / rollWidthM);
  }

  function calculateSquareMetreQuantity(wallWidthCm, wallHeightCm) {
    if (!wallWidthCm || !wallHeightCm) {
      return 1;
    }

    const wallAreaM2 = (wallWidthCm / 100) * (wallHeightCm / 100);

    return Math.ceil(wallAreaM2);
  }

  function updateSelectedVariantId(event) {
    const variant = event.detail && event.detail.variant;

    if (variant && variant.id) {
      variantInput.value = variant.id;
    }
  }

  document.addEventListener('variant:change', updateSelectedVariantId);

  button.addEventListener('click', function () {
    const wallWidthCm = getNumber(widthInput.value);
    const wallHeightCm = getNumber(heightInput.value);

    const sellingUnit = normalizeSellingUnit(calculator.dataset.sellingUnit);
    const rollWidthCm = getNumber(calculator.dataset.rollWidthCm);
    const rollLengthM = getNumber(calculator.dataset.rollLengthM);
    const verticalRepeatCm = getNumber(calculator.dataset.verticalRepeatCm || 0);

    if (!wallWidthCm || !wallHeightCm) {
      alert('Inserisci larghezza e altezza della parete.');
      return;
    }

    let requiredQty = 1;
    let unitLabel = 'unità';

    if (sellingUnit === 'rollo' || sellingUnit === 'rotolo' || sellingUnit === 'roll') {
      if (!rollWidthCm) {
        alert('Roll width is missing in product metafields.');
        return;
      }

      if (!rollLengthM) {
        alert('Roll length is missing in product metafields.');
        return;
      }

      requiredQty = calculateRollQuantity(
        wallWidthCm,
        wallHeightCm,
        rollWidthCm,
        rollLengthM,
        verticalRepeatCm
      );

      unitLabel = 'rotolo/i';
    } else if (
      sellingUnit === 'metro lineare' ||
      sellingUnit === 'linear metre' ||
      sellingUnit === 'linear meter' ||
      sellingUnit === 'linear metre(s)'
    ) {
      if (!rollWidthCm) {
        alert('Roll width is missing in product metafields.');
        return;
      }

      requiredQty = calculateLinearMetreQuantity(wallWidthCm, wallHeightCm, rollWidthCm);
      unitLabel = 'metro/i lineare/i';
    } else if (
      sellingUnit === 'm2' ||
      sellingUnit === 'm²' ||
      sellingUnit === 'mq' ||
      sellingUnit === 'sqm'
    ) {
      requiredQty = calculateSquareMetreQuantity(wallWidthCm, wallHeightCm);
      unitLabel = 'm²';
    } else if (sellingUnit === 'campione') {
      requiredQty = 1;
      unitLabel = 'campione';
    } else if (sellingUnit === 'murale') {
      requiredQty = 1;
      unitLabel = 'murale';
    } else {
      requiredQty = 1;
      unitLabel = 'unità';
    }

    requiredQty = Math.max(1, requiredQty);

    console.log('Wallpaper calculator values:', {
      sellingUnit,
      wallWidthCm,
      wallHeightCm,
      rollWidthCm,
      rollLengthM,
      verticalRepeatCm,
      requiredQty
    });

    qtyOutput.textContent = requiredQty;
    unitOutput.textContent = unitLabel;
    cartQtyInput.value = requiredQty;

    if (wallWidthProperty) {
      wallWidthProperty.value = wallWidthCm + ' cm';
    }

    if (wallHeightProperty) {
      wallHeightProperty.value = wallHeightCm + ' cm';
    }

    if (calculatedQtyProperty) {
      calculatedQtyProperty.value = requiredQty + ' ' + unitLabel;
    }

    resultBox.hidden = false;
    cartButton.disabled = false;
  });

  cartForm.addEventListener('submit', function () {
    const currentQty = parseInt(cartQtyInput.value, 10);

    if (!currentQty || currentQty < 1) {
      cartQtyInput.value = 1;
    }
  });


function initCurtainModule() {
  const modules = document.querySelectorAll('[data-curtain-module]');
  if (!modules.length) return;

  modules.forEach(function (module) {
    let pendingItems = [];

    const typeInputs = module.querySelectorAll('input[type="radio"][name^="curtain_type_"]');
    const panels = module.querySelectorAll('[data-curtain-panel]');
    const result = module.querySelector('[data-curtain-result]');
    const addButton = module.querySelector('[data-add-curtain-cart]');

    let fabricPriceCents = parseInt(module.dataset.fabricPriceCents || '0', 10);
    let fabricVariantId = module.dataset.fabricVariantId;
    const currencyCode = module.dataset.currencyCode || 'EUR';
    const classicServicePriceCents = parseInt(module.dataset.classicServicePriceCents || '0', 10);
    
    document.addEventListener('variant:change', function(event){

      const variant = event.detail && event.detail.variant;

      if (!variant) return;

      fabricVariantId = variant.id;
      fabricPriceCents = variant.price;

      module.dataset.fabricVariantId = variant.id;
      module.dataset.fabricPriceCents = variant.price;

    });
    
    // document.addEventListener('variant:change', function(event) {

    //   const variant = event.detail && event.detail.variant;

    //   if (!variant) return;

    //   const selectedOptions = variant.options || [];

    //   const optionContainers = document.querySelectorAll('.variant-picker__option-info');

    //   optionContainers.forEach(function(container, index){

    //     const value = container.querySelector('span');

    //     if(value && selectedOptions[index]){
    //       value.textContent = selectedOptions[index];
    //     }

    //   });

    // });
    
    typeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.curtainPanel !== input.value;
        });

        pendingItems = [];
        result.hidden = true;
        result.innerHTML = '';
        addButton.disabled = true;
      });
    });

    const classicButton = module.querySelector('[data-calculate-classic]');

    if (classicButton) {
      classicButton.addEventListener('click', function () {
        const panelsSelect = module.querySelector('[data-classic-panels]');
        const heightInput = module.querySelector('[data-classic-height]');

        const panelsCount = parseInt(panelsSelect.value, 10);
        const height = parseFloat(heightInput.value);

        const brackets = parseJson(module.dataset.classicBrackets, []);
        const bracket = brackets.find(function (item) {
          return height >= Number(item.min) && height <= Number(item.max);
        });

        if (!height || !bracket) {
          alert("Si prega di inserire un'altezza della tenda valida, compresa nell'intervallo disponibile.");
          return;
        }

        //const fabricVariantId = module.dataset.fabricVariantId;
        const serviceVariantId = module.dataset.classicServiceVariantId;

        if (!fabricVariantId || !serviceVariantId) {
          alert('Fabric or classic making service variant is missing.');
          return;
        }

        const fabricMetres = Number(bracket.metres) * panelsCount;
        const fabricQty = fabricMetresToQuantity(fabricMetres, module.dataset.fabricUnitStep);
        const fabricTotalCents = fabricQty * fabricPriceCents;
        const fabricTotalFormatted = formatCurtainMoney(fabricTotalCents, currencyCode);

        const serviceTotalCents = classicServicePriceCents * panelsCount;
        const serviceTotalFormatted = formatCurtainMoney(serviceTotalCents, currencyCode);

        const grandTotalCents = fabricTotalCents + serviceTotalCents;
        const grandTotalFormatted = formatCurtainMoney(grandTotalCents, currencyCode);

        pendingItems = [
        {
          id: fabricVariantId,
          quantity: fabricQty,
          properties: {
            'articolo': 'tessuto per tende a caduta',
            'tenda a pacchetto': 'tende a caduta',
            'pannelli': String(panelsCount),
            'altezza': height + ' cm',
            'quantità tessuto': fabricMetres.toFixed(2) + ' m',
            'totale tessuto': fabricTotalFormatted,
            'servizio': serviceTotalFormatted,
            'TOTALE': grandTotalFormatted
          }
        },
        {
          id: serviceVariantId,
          quantity: panelsCount,
          properties: {
            'articolo': 'servizio tenda classica',
            'tenda a pacchetto': 'tende a caduta',
            'pannelli': String(panelsCount),
            'altezza': height + ' cm',
            'quantità tessuto': fabricMetres.toFixed(2) + ' m',
            'servizio': serviceTotalFormatted,
            'TOTALE': grandTotalFormatted
          }
        }
      ];

      console.log('Classic curtain pending items:', pendingItems);

        showCurtainResult(result, [
          ['tenda a pacchetto', 'tenda classica'],
          ['larghezza', panelsCount],
          ['altezza', height + ' cm'],
          ['quantità tessuto', fabricMetres.toFixed(2) + ' m'],
          ['totale tessuto', fabricTotalFormatted],
          ['servizio', serviceTotalFormatted],
          ['TOTALE', grandTotalFormatted]
        ]);

        addButton.disabled = false;
      });
    }

    const romanButton = module.querySelector('[data-calculate-roman]');

    if (romanButton) {
      romanButton.addEventListener('click', function () {
        const widthInput = module.querySelector('[data-roman-width]');
        const heightInput = module.querySelector('[data-roman-height]');

        const width = parseFloat(widthInput.value);
        const height = parseFloat(heightInput.value);

        if (!width || !height || width > 250) {
          alert('Please enter a valid width up to 250 cm and height.');
          return;
        }

        //const fabricVariantId = module.dataset.fabricVariantId;
        const fabricWidthMode = module.dataset.fabricWidthMode || '140';

        const priceBrackets = parseJson(module.dataset.romanWidthPrices, []);
        const fabricBracketsData = parseJson(module.dataset.romanFabricBrackets, {});
        const fabricBrackets = fabricBracketsData[fabricWidthMode] || [];

        const priceBracket = priceBrackets.find(function (item) {
          return width > Number(item.min) && width <= Number(item.max);
        });

        const fabricBracket = fabricBrackets.find(function (item) {
          const widthOk = item.minWidth === undefined || (width >= Number(item.minWidth) && width <= Number(item.maxWidth));
          const heightOk = height >= Number(item.minHeight) && height <= Number(item.maxHeight);

          return widthOk && heightOk;
        });

        if (!priceBracket) {
          alert('No Roman blind price bracket found for this width.');
          return;
        }

        if (!fabricBracket) {
          alert('No fabric requirement bracket found for this width and height.');
          return;
        }

        const serviceVariantId = priceBracket.service_variant_id;
        

        if (!fabricVariantId || !serviceVariantId) {
          alert('Fabric or Roman blind service variant is missing.');
          return;
        }

        const fabricMetres = Number(fabricBracket.metres);
        const fabricQty = fabricMetresToQuantity(fabricMetres, module.dataset.fabricUnitStep);

        const fabricTotalCents = fabricQty * fabricPriceCents;
        const fabricTotalFormatted = formatCurtainMoney(fabricTotalCents, currencyCode);
        
        const serviceTotalCents = classicServicePriceCents;
        const serviceTotalFormatted = formatCurtainMoney(serviceTotalCents, currencyCode);

        const grandTotalCents = fabricTotalCents + serviceTotalCents;
        const grandTotalFormatted = formatCurtainMoney(grandTotalCents, currencyCode);

        pendingItems = [
          {
            id: Number(fabricVariantId),
            quantity: fabricQty,
            properties: {
              'Item type': 'Fabric for roman blind',
              'Curtain type': 'Roman blind',
              'Width': width + ' cm',
              'Height': height + ' cm',
              'Fabric required': fabricMetres.toFixed(2) + ' m',
              'Fabric total': fabricTotalFormatted
            }
          },
          {
            id: Number(serviceVariantId),
            quantity: 1,
            properties: {
              'Item type': 'Roman blind making and system',
              'Curtain type': 'Roman blind',
              'Width': width + ' cm',
              'Height': height + ' cm',
              'Fabric required': fabricMetres.toFixed(2) + ' m'
            }
          }
        ];

        showCurtainResult(result, [
          ['tenda a pacchetto', 'tenda a pachetto'],
          ['larghezza', width + ' cm'],
          ['altezza', height + ' cm'],
          ['quantità tessuto', fabricMetres.toFixed(2) + ' m'],
          ['totale tessuto', fabricTotalFormatted],
          ['servizio', serviceTotalFormatted],
          ['TOTALE', grandTotalFormatted]
        ]);

        addButton.disabled = false;
      });
    }

    addButton.addEventListener('click', async function () {
      if (!pendingItems.length) return;

      addButton.disabled = true;

      try {
        console.log('Curtain pending items:', pendingItems);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: pendingItems
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add curtain configuration to cart.');
        }

        window.location.href = '/cart';
      } catch (error) {
        alert(error.message || 'Something went wrong.');
        addButton.disabled = false;
      }
    });
  });
}

function parseJson(value, fallback) {
  try {
    return JSON.parse(value || '');
  } catch (error) {
    return fallback;
  }
}

function fabricMetresToQuantity(metres, stepValue) {
  const step = parseFloat(stepValue || '1');

  if (!step || step <= 0) {
    return Math.ceil(metres);
  }

  return Math.ceil(metres / step);
}

function formatCurtainMoney(cents, currencyCode) {
  const amount = Number(cents || 0) / 100;

  try {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currencyCode || 'EUR'
    }).format(amount);
  } catch (error) {
    return '€' + amount.toFixed(2);
  }
}

function showCurtainResult(result, rows) {
  result.innerHTML = rows.map(function (row) {
    return `
      <div class="curtain-result-row">
        <span>${row[0]}</span>
        <strong>${row[1]}</strong>
      </div>
    `;
  }).join('');

  result.hidden = false;
}

function initSampleAddLimit() {
  const forms = document.querySelectorAll('[data-sample-add-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      const sampleVariantId = String(form.dataset.sampleVariantId || '');
      const parentProductId = String(form.dataset.parentProductId || '');
      const submitButton = form.querySelector('button[type="submit"]');

      if (!sampleVariantId) {
        alert('Sample variant ID is missing.');
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        const cartResponse = await fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        });

        const cart = await cartResponse.json();

        const existingSample = cart.items.find(function (item) {
          const itemParentProductId = item.properties && item.properties['_Parent product id'];

          return String(item.variant_id) === sampleVariantId
            && String(itemParentProductId) === parentProductId;
        });

        if (existingSample) {
          if (existingSample.quantity !== 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: existingSample.key,
                quantity: 1
              })
            });
          }

          alert('This sample is already in your cart.');
          window.location.href = '/cart';
          return;
        }

        const formData = new FormData(form);
        formData.set('quantity', '1');

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });

        const data = await addResponse.json();

        if (!addResponse.ok) {
          throw new Error(data.description || data.message || 'Could not add sample to cart.');
        }

        window.location.href = '/cart';
      } catch (error) {
        alert(error.message || 'Something went wrong.');

        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  });
}